import { render, staticRenderFns } from "./PeopleTourActivityDetail.vue?vue&type=template&id=df663cb2"
import script from "./PeopleTourActivityDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PeopleTourActivityDetail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports